import { get, post, put, del } from "./http";

// Mirrors ordr-flutter Repository location/* calls
export const getLocations = () => get("/buyer/location");

export const createLocation = (payload) => post("/buyer/location", payload);
// payload: { locationName, locationType, streetAddress, city, state, zip, locationPhone, locationContactPersonName }

export const updateLocation = (locationId, payload) => put(`/buyer/location/${locationId}`, payload);

export const deleteLocation = (locationId) => del(`/buyer/location/${locationId}`);

export const updateLocationProducts = (locationId, payload) => put(`/buyer/locationProduct/${locationId}`, payload);

export const updateLocationConsumption = (locationId, payload) => put(`/buyer/locationConsumption/${locationId}`, payload);

export const updateLocationAccess = (locationId, payload) => put(`/buyer/locationAccess/${locationId}`, payload);

export const updateLocationNotes = (locationId, payload) => put(`/buyer/locationNotes/${locationId}`, payload);
